import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import { AuthProvider } from './context/AuthContext';

// Global error handlers to catch ChunkLoadErrors that escape React's ErrorBoundary
const clearCachesAndReload = async () => {
  try {
    if (typeof caches !== 'undefined') {
      const names = await caches.keys();
      await Promise.all(names.map(name => caches.delete(name)));
    }
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(reg => reg.unregister()));
    }
  } catch (_) {
    // ignore errors during cleanup
  }
  window.location.reload();
};

const handleChunkError = (error: any) => {
  const isChunkError = 
    error?.name === 'ChunkLoadError' || 
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('Unexpected token');

  if (isChunkError) {
    console.error('Global Chunk Error detected. Clearing SW caches and reloading...');
    const lastReloadStr = sessionStorage.getItem('chunk_last_reload');
    const lastReload = lastReloadStr ? parseInt(lastReloadStr, 10) : 0;
    
    // Prevent infinite reload loop (only reload if last reload was > 10 seconds ago)
    if (Date.now() - lastReload > 10000) {
      sessionStorage.setItem('chunk_last_reload', Date.now().toString());
      clearCachesAndReload();
    } else {
      console.error('ChunkLoadError persists after reload. Halting to prevent infinite loop.');
    }
  }
};

window.addEventListener('unhandledrejection', (event) => {
  handleChunkError(event.reason);
});

window.addEventListener('error', (event) => {
  handleChunkError(event.error || { message: event.message });
});


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA capabilities
serviceWorker.register({
  onSuccess: () => console.log('Xpertify is now available offline!'),
  onUpdate: (registration) => {
    // Create a custom notification to inform the user of an update
    const updateAvailable = document.createElement('div');
    updateAvailable.className = 'fixed bottom-4 left-4 right-4 bg-red-500 dark:bg-red-600 text-white p-3 rounded-lg shadow-lg z-50 flex items-center justify-between';
    updateAvailable.innerHTML = `
      <span>A new version of Xpertify is available!</span>
      <button id="update-app" class="bg-white text-red-500 dark:text-red-600 px-3 py-1 rounded-md text-sm font-medium">
        Update Now
      </button>
    `;
    document.body.appendChild(updateAvailable);

    // Add event listener to the update button
    document.getElementById('update-app')?.addEventListener('click', () => {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    });
  }
});
